module.exports = __webpack_public_path__ + "img/top-banner.60723241.png";